import { Field, FieldProps } from 'formik';

export function AddressInput() {

    return (
        <Field name="address">
            {(props: FieldProps) => {
                const { field: {value, ...field} } = props;
                return (
                    <div>
                        <label htmlFor="address" className="block mb-2 text-sm font-medium text-gray-900">Address</label>
                        <input
                            type="text"
                            className={"bg-gray-50 border border-gray-300 focus:border-blue-500 focus:ring-blue-500 text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-1 focus:border w-full p-2.5"}
                            defaultValue={value}
                            {...field}
                        />
                    
                    </div>
                );
            }}
        </Field>
    );
}